<template>
  <router-link
    class="nav-link"
    :class="{'dropdown-item': isDropdown}"
    :to="`/${to ?? name.toLowerCase()}`"
    active-class="custom-active">
    {{ name }}
  </router-link>
</template>

<script setup lang="ts">
import {defineProps} from 'vue';

defineProps<{
  name: string;
  to?: string;
  isDropdown?: boolean;
}>();
</script>

<style lang="scss" scoped>
.custom-active {
  color: var(--green) !important;
}
</style>
